import { useSearchParams } from 'react-router'

import { HIGHLIGHT_JUMP_PARAM } from '@/api/services/highlight'

/** URL の ?hl= で指定された、開いたときにジャンプするハイライトの id */
export const useHighlightJumpId = (): number | null => {
  const [searchParams] = useSearchParams()
  const id = Number(searchParams.get(HIGHLIGHT_JUMP_PARAM))
  return Number.isInteger(id) && id > 0 ? id : null
}
